import { Box, TableContainer, TableCaption, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';

function DataTable({ data, setSelectedItem, setSelectedMediaType, setMediaLoading }) {
  // Assuming all objects in the array have the same keys.
  // Get the keys from the first object in the array to use as headers.
  let headers = data.length > 0 ? Object.keys(data[0]) : [];
  const headersToRemove = ['MediaLocation', 'MediaStoreLocation', 'MediaLocationType', 'TTL', 'GatewayTaskId', 'DeliveryProvider' ]
  headers = headers.filter(header => !headersToRemove.includes(header));
  headers.sort();

  const handleNameClick = (mediaLocation, channel, Id) => {
    setSelectedMediaType(channel);
    setMediaLoading(true)
    let identifier
    if(channel === 'VOICE' || channel === 'TASK'){
      identifier = Id
    } else if(channel === 'SMS' || channel === 'WEBCHAT' || channel === 'EMAIL'){
      identifier = mediaLocation
    }
    
    setSelectedItem(identifier);
    
  };

  const dateConvert = (isoDate) => {
    let thisDate = new Date(isoDate).toLocaleString()
    return thisDate
  }

  return (
    <Box>
        <TableContainer>
            
            <Table size='sm' variant='striped' colorScheme='blackAlpha'>
                <TableCaption>Interaction Report</TableCaption>
                <Thead>
                <Tr>
                    {headers.map(header => (
                    <Th key={header}>{header}</Th>
                    ))}
                </Tr>
                </Thead>
                <Tbody>
                {data.map((item, rowIndex) => (
                    <Tr 
                      key={rowIndex}
                      _hover={{ bg: "green.200" }} // Highlight background color on hover
                      cursor="pointer"
                      onClick={() => handleNameClick(item['MediaLocation'], item['Channel'], item['GatewayTaskId'])}
                    >
                    {headers.map(header => (
                        <Td
                        key={header}
                        >
                        {header === 'InitiationTimestamp' ? dateConvert(item[header]) : item[header]}
                        </Td>
                    ))}
                    </Tr>
                ))}
                </Tbody>
                
            </Table>
        </TableContainer>
    </Box>
  );
}

export default DataTable;
